<template>
  <div class="contect-phone">
    <div style="min-width: 1086px">
      <el-form ref="form" :inline="true" :model="form" :rules="rules" class="demo-form-inline" label-width="100px">
        <el-form-item prop="phone">
          <template>
            <span slot="label" style="color: #fff; letter-spacing: 2px; font-size: 16px">手机号码</span>
          </template>
          <el-input v-model="form.phone" size="small" placeholder="请输入您的手机号" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <template>
            <span slot="label" style="color: #fff; letter-spacing: 2px; font-size: 16px">公司名称</span>
          </template>
          <el-input v-model="form.name" size="small" placeholder="请输入您的公司名称" maxlength="60"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="onSubmit">提交对接意向</el-button>
        </el-form-item>
      </el-form>
      <div class="font-style">
        <span>*</span>
        <span> 留下您的联系方式，稍后我们会联系您并深入对接您的需求</span>
      </div>
    </div>
  </div>
</template>

<script>
import { addCrm } from '@/api/user'
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        callback()
      }
    }
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'))
      } else {
        callback()
      }
    }
    return {
      form: {
        phone: '',
        name: '',
        email: ''
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        name: [
          {
            validator: validateName,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          addCrm(this.form).then(res => {
            this.form = {
              phone: '',
              name: '',
              email: ''
            }
            this.$message.success(res.data)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contect-phone {
  display: flex;
  justify-content: center;
  padding: 54px 0 26px 0;
  min-width: 1200px;
  //   height: 140px;
  background: linear-gradient(149deg, #cadffb 0%, #4e9aff 28%, #8ebaff 61%, #97c6ff 100%);
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .btn {
    width: 124px;
    font-size: 14px;
    line-height: 6px;
    background: #1170eb;
    border-color: #1170eb;
    border-radius: 4px;
    margin-left: 30px;
  }
  .font-style {
    font-size: 14px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    span {
      letter-spacing: 2px;
    }
    span:first-child {
      color: #ff1212;
      margin-right: 4px;
    }
  }
}
</style>
